var main = require('org_km/main');

main.baseFiles.menu = require('./components/menu');
main.baseFiles.countryConfirmation = require('./components/countryConfirmation');
main.baseFiles.countrySelector = require('./components/countrySelector');
main.baseFiles.tile = require('./product/tile');
main.baseFiles.base = require('./product/base');
main.baseFiles.cart = require('./cart');
main.baseFiles.miniCart = require('./components/miniCart');
main.baseFiles.refersion = require('./integrations/refersion/welcome');
main.baseFiles.customerChildLogin = require('./components/customerChildLogin');
main.baseFiles.quickView = require('./product/quickView');

var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
var toggleObject = siteIntegrations.getIntegrationSettings();
if (toggleObject.klaviyo_enabled) {
    main.baseFiles.klaviyo = require('./integrations/klaviyo/identify');
}

module.exports = main;
